import st from "@/styles/AccountPage.module.scss"
import Button from "@/ui/Button.tsx";
import LockIcon from "@/svg/LockIcon.tsx";
import {useTranslation} from "react-i18next";
import {useAtom} from "jotai/index";
import {set_pwd_modal_atom} from "@/atoms/modals.ts";
import {profile} from "@/atoms/profile.ts";
// import useAuth from "@/hooks/auth.ts";
import {useCallback, useEffect, useState} from "react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import LoginLoader from "@/ui/LoginLoader.tsx";
// import {resend_interval} from "@/atoms/common.ts";
// import useIntervals from "@/hooks/intervals.ts";



const SetPwd = () => {

    const {t} = useTranslation()
    const [open_modal, setOpen] = useAtom(set_pwd_modal_atom)
    const [user] = useAtom(profile)
    // const auth = useAuth()
    // const intervals_hook = useIntervals(resend_interval)
    const [loading, set_loading] = useState<boolean>(false)
    const [, set_otp_error] = useState<boolean>(false)
    const [, set_pwd_error] = useState<boolean>(false)
    // const [interval] = useAtom(resend_interval)

    const set_loading_handler = useCallback((x: boolean) => {
        if(!open_modal) set_loading(x);
    }, [set_loading, open_modal]);

    const set_otp_err_handler = useCallback((x: boolean) => {
        if(!open_modal) set_otp_error(x);
    }, [set_otp_error, open_modal]);

    const set_pwd_err_handler = useCallback((x: boolean) => {
        if(!open_modal) set_pwd_error(x);
    }, [set_pwd_error, open_modal]);

    // const resetHandlerStepOne = async () => {
    //
    //
    //
    //     if(!user || user.email.length === 0) return
    //
    //     let reset: boolean = false
    //
    //     if(interval !==  null && interval.length) {
    //         reset = true
    //     } else {
    //         reset = await auth.resetPwdSt1("email", user?.email)
    //         intervals_hook.setIntervalHandler()
    //         eventEmitter.emit(CommonClass.CustomEvents.set_resend_interval, true)
    //     }
    //
    //     if(reset) {
    //         setOpen(true)
    //     }
    // }

    useEffect(() => {

        eventEmitter.on(CommonClass.CustomEvents.set_req_load, set_loading_handler)
        eventEmitter.on(CommonClass.CustomEvents.set_err_otp, set_otp_err_handler)
        eventEmitter.on(CommonClass.CustomEvents.set_err_pwd, set_pwd_err_handler)
        eventEmitter.emit(CommonClass.CustomEvents.set_err_pwd, false)
        eventEmitter.emit(CommonClass.CustomEvents.set_err_otp, false)
        
        return () => {

            eventEmitter.off(CommonClass.CustomEvents.set_req_load, set_loading_handler)
            eventEmitter.off(CommonClass.CustomEvents.set_err_otp, set_otp_err_handler)
            eventEmitter.off(CommonClass.CustomEvents.set_err_pwd, set_pwd_err_handler)

        }

    }, []);


    return (
        <div className={st.set_pwd}>
            <Button
                disabled={loading || !user?.permissions?.is_pass_code_modifiable}
                // disabled={true}
                className={st.btn}
                outlined
                onClick={() => {
                    // resetHandlerStepOne()
                    setOpen(true)
                }}
            >
                <>
                    <LockIcon />

                    <span>{user?.is_pass_code_set ? t("reset_pwd") : t("set_pin")}</span>
                </>
            </Button>

            {loading && (
                <LoginLoader />
            )}


        </div>
    )
}

export default SetPwd